import { Alert, Box, Container, Grid, Snackbar } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./JobDetailsModal.css";
import ShareModalJob from "./ShareModalJob";
import JobDetailsCard from "./JobDetailsCard";
import JobSidebar from "./JobSidebar";
import { tokens } from "../../store/tokens";
import { useSessionUser } from '../../store/useSessionUser';

const shareModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  maxWidth: "90vw",
  bgcolor: tokens.bg.surface,
  borderRadius: `${tokens.radius.lg}px`,
  boxShadow: tokens.shadow.lg,
  p: 4,
};

const JobDetails = () => {
  const { jobId, jobRefer, poid } = useParams();
  const { user, isLogged, setIsLogged, isMember } = useSessionUser();

  const [fetchJobDetails, setFetchJobDetails] = useState();
  const [isApplication, setIsApplication] = useState(false);
  const [isLogin, setIsLogin] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [open, setOpen] = useState(false);

  const [form, setForm] = useState({
    name: "",
    phone: "",
    email: "",
    password: "",
    address: "",
    city: "",
    country: "",
    scheduledDelivery: "",
    pickupPlace: "",
    receivingPlace: "",
    paymentOption: "cod",
  });

  const [snackMessage, setSnackMessage] = useState("");
  const [snackOpen, setSnackOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSnackOpen = (message) => {
    setSnackMessage(message);
    setSnackOpen(true);
  };
  const handleSnackClose = (event, reason) => {
    if (reason === "clickaway") return;
    setSnackOpen(false);
  };

  useEffect(() => {
    const formData = new FormData();
    formData.append("gid", jobId);
    formData.append("refer", jobRefer);
    formData.append("poid", poid);
    formData.append("userId", user?.sopnoid ?? "");

    fetch(
      "https://aps.songjukti.com/profile/login/api_job/new_24/job_details.php",
      { method: "POST", body: formData }
    )
      .then((res) => res.json())
      .then((result) => setFetchJobDetails(result))
      .catch((error) => console.log("JobDetailsApiError=> ", error));
  }, [jobId, jobRefer, poid, user?.sopnoid]);

  return (
    <Container maxWidth="lg" sx={{ mt: 3, mb: 4 }}>
      <Snackbar
        open={snackOpen}
        autoHideDuration={4000}
        onClose={handleSnackClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      >
        <Alert
          onClose={handleSnackClose}
          severity="info"
          sx={{ width: "100%", borderRadius: `${tokens.radius.sm}px` }}
        >
          {snackMessage}
        </Alert>
      </Snackbar>

      <Box sx={{ mt: { xs: 9, sm: 4 }, pb: "20px" }}>
        <Grid
          container
          sx={{
            border: `1px solid ${tokens.color.line}`,
            borderRadius: `${tokens.radius.lg}px`,
            overflow: "hidden",
            bgcolor: tokens.bg.surface,
            boxShadow: tokens.shadow.sm,
          }}
        >
          {/* LEFT: Job Details */}
          <Grid
            item
            xs={12}
            md={8}
            sx={{
              borderRight: { xs: "none", md: `1px solid ${tokens.color.line}` },
              borderBottom: { xs: `1px solid ${tokens.color.line}`, md: "none" },
            }}
          >
            <JobDetailsCard fetchJobDetails={fetchJobDetails} />
          </Grid>

          {/* RIGHT: Sidebar / Apply Section */}
          <Grid item xs={12} md={4}>
            <JobSidebar
              isApplication={isApplication}
              isLogged={isLogged}
              isLogin={isLogin}
              setIsLogin={setIsLogin}
              loading={loading}
              setLoading={setLoading}
              setIsSubmitting={setIsSubmitting}
              setIsLogged={setIsLogged}
              setIsApplication={setIsApplication}
              user={user}
              form={form}
              setForm={setForm}
              fetchJobDetails={fetchJobDetails}
              isMember={isMember}
              handleSnackOpen={handleSnackOpen}
              handleSnackClose={handleSnackClose}
              handleOpen={handleOpen}
            />
          </Grid>
        </Grid>
      </Box>

      <ShareModalJob
        handleClose={handleClose}
        open={open}
        profileDetails={fetchJobDetails}
        style={shareModalStyle}
      />
    </Container>
  );
};

export default JobDetails;